import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { OrderFulfillmentMethod } from '../enums/OrderFulfillmentMethod'
import type { OrderStatus } from '../enums/OrderStatus'
import type { InvoiceEntity } from './InvoiceEntity'
import type { OrderAddressEntity } from './OrderAddressEntity'
import type { OrderBranchEntity } from './OrderBranchEntity'
import type { OrderPaymentType } from '../enums/OrderPaymentType'
import type { OrderPaymentStatus } from '../enums/OrderPaymentStatus'
import type { OrderDiscountEntity } from './OrderDiscountEntity'
import type { ShipmentEntity } from '@/features/shipment/domain/entities/ShipmentEntity'
import type { OrderTag } from '@/features/trackOrder/domain/enums/OrderTag'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { OrderLiveAssignedDriverEntity } from '@/features/trackOrder/domain/entities/orderEntities/OrderLiveAssignedDriverEntity'
export class OrderEntity {
  id?: string
  user?: UserMiniEntity
  branch?: OrderBranchEntity
  referenceCode?: string | null
  trackingPanelUser?: {
    userDisplayName?: string
    userPhoneNumber?: string
    userId?: string
  }
  region?: RegionMiniEntity
  status?: OrderStatus
  address?: OrderAddressEntity
  paymentType?: OrderPaymentType
  fulfillmentMethod?: OrderFulfillmentMethod
  orderPaymentStatus?: OrderPaymentStatus
  invoice?: InvoiceEntity
  branchNote?: string | null
  driverNote?: string | null
  hasSensitiveItem?: boolean
  estimatedPreparationTime?: string | null
  assignedDriver?: OrderLiveAssignedDriverEntity
  preparedAt?: string | null
  jetOrder?: {
    branchDeliveryFeeShareAmount?: number
    invoiceImagePath?: string | null
  }
  discount?: OrderDiscountEntity
  createdAt?: string
  latestShipment?: ShipmentEntity
  tags?: OrderTag[]
  serviceId?: number
  serviceName?: string | null
  zohoBooksInvoiceId?: string | null
  zohoBooksPaymentId?: string | null
  zohoBooksCreditAppliedAt?: string | null
  scheduledOrderTime?: string | null
  unavailableItemPreference?: {
    title?: string | null
  }
}
